/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Role_HelpInputs */

const en_team_manager_role_help = /** @type {(inputs: Team_Manager_Role_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select the user's role in the system`)
};

const fr_team_manager_role_help = /** @type {(inputs: Team_Manager_Role_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez le rôle de l’utilisateur dans le système`)
};

const de_team_manager_role_help = /** @type {(inputs: Team_Manager_Role_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie die Rolle des Benutzers im System aus.`)
};

const it_team_manager_role_help = /** @type {(inputs: Team_Manager_Role_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona il ruolo dell'utente nel sistema`)
};

const ru_team_manager_role_help = /** @type {(inputs: Team_Manager_Role_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите роль пользователя в системе.`)
};

const es_team_manager_role_help = /** @type {(inputs: Team_Manager_Role_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione el rol del usuario en el sistema`)
};

const zh_cn2_team_manager_role_help = /** @type {(inputs: Team_Manager_Role_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择用户在系统中的角色`)
};

const ja_team_manager_role_help = /** @type {(inputs: Team_Manager_Role_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`システム内でのユーザーの役割を選択する`)
};

const hi_team_manager_role_help = /** @type {(inputs: Team_Manager_Role_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सिस्टम में उपयोगकर्ता की भूमिका का चयन करें`)
};

const pt_pt2_team_manager_role_help = /** @type {(inputs: Team_Manager_Role_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione a função do usuário no sistema.`)
};

/**
* | output |
* | --- |
* | "Select the user's role in the system" |
*
* @param {Team_Manager_Role_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_role_help = /** @type {((inputs?: Team_Manager_Role_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Role_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_role_help(inputs)
	if (locale === "de") return de_team_manager_role_help(inputs)
	if (locale === "it") return it_team_manager_role_help(inputs)
	if (locale === "ru") return ru_team_manager_role_help(inputs)
	if (locale === "es") return es_team_manager_role_help(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_role_help(inputs)
	if (locale === "ja") return ja_team_manager_role_help(inputs)
	if (locale === "hi") return hi_team_manager_role_help(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_role_help(inputs)
	return en_team_manager_role_help(inputs)
});